import { categoryStyles } from '@/utils/categoryStyles';

export const CategoryCard = ({ category, onClick }) => {
  const style = categoryStyles[category.id] || { bg: "bg-emerald-500", emoji: "📦", color: "from-emerald-400 to-emerald-600" };
  
  return (
    <div 
      className="category-card flex flex-col items-center justify-center text-center group cursor-pointer"
      onClick={onClick}
      data-testid={`category-${category.id}`}
    >
      <div className={`w-16 h-16 rounded-2xl bg-gradient-to-br ${style.color} flex items-center justify-center mb-3 shadow-lg group-hover:scale-110 group-hover:rotate-6 transition-all duration-300 group-hover:shadow-xl`}>
        <span className="text-3xl">{style.emoji}</span>
      </div>
      <span className="font-medium text-sm group-hover:text-emerald-600 transition-colors">{category.name}</span>
    </div>
  );
};

export default CategoryCard;
